// this will need the translateChoice prop on the component
export const statusChoices = [
  { id: 'pending', name: 'offer.status.pending' },
  { id: 'accepted', name: 'offer.status.accepted' },
  { id: 'ended', name: 'offer.status.ended' },
];

export const pricingModelChoices = [
  { id: 'cost-per-click', name: 'Clicks' },
  { id: 'lead-generation', name: 'Leads' },
  { id: 'cost-per-acquisition', name: 'Conversions' },
  { id: 'flat-fee', name: 'Flat Fee' },
];

export const declineReasons = [
  { id: 'low-budget', name: 'Low budget' },
  { id: 'pricing-model', name: 'Pricing model' },
  { id: 'low-rate', name: 'Low rate' },
  { id: 'audience', name: 'Audience' },
  { id: 'brand', name: 'Brand' },
  { id: 'timing', name: 'Timing' },
  { id: 'direct-relationships', name: 'Direct relationships' },
  { id: 'other', name: 'Other' },
];
